<template>
    <div class="TTL-upload-btn"><wcbutton :option="{title:'上传视频'}" @finish="uploadimages" /></div>
    <vue3VideoPlay v-bind="playparam.options" ref="videoPlayer"  v-if="playparam.options.src && playparam.options.src!=''"/>
    
</template>

<script>
import INTERFACE_MODEL_BASE from '@/Interface/index';
export default {
  props: ['value'],
  data() {
      return {
          playparam: {
              view:false,
              options:{
                  width:'420px',
                  height:'236px',
                  color: "#409eff", //主题色
                  title: '', //视频名称
                  src: this.value, //视频源
                  muted: false, //静音
                  webFullScreen: false,
                  speedRate: ["0.75", "1.0", "1.25", "1.5", "2.0"], //播放倍速
                  autoPlay: false, //自动播放
                  loop: false, //循环播放
                  mirror: false, //镜像画面
                  ligthOff: false,  //关灯模式
                  volume: 0.3, //默认音量大小
                  control: true, //是否显示控制器
              }
          },

      }
  },

  watch: {
      value(val) {
          this.playparam.options.src=val;
      },
  },

  mounted() {
      
  },

  methods: {

      uploadimages() {
          var _this=this;
          var files;
          var obj=document.querySelector('#TTLFiles');  //获取文件对象
          obj.click();  //点击触发上传图片
          obj.onchange=(e)=> {
              files=e.srcElement.files[0]; //提取文件
              e.srcElement.value=null;     //清空已选的文件
              INTERFACE_MODEL_BASE.UPLOAD_FILES({imageType:'library',File:files}).then((res) => {
                  if(res.status > 0) return false;
                  _this.playparam.options.src=process.env.VUE_APP_IMAGE_ADDRESS+res.data.videourl;
                  _this.$emit('finish',{url:_this.playparam.options.src});
              });
          }
      },

  }

}
</script>

<style scoped>
.large {cursor: pointer;width:auto !important;width:420px !important;height:236px;position:relative;}
.large .el-image {width:100px;height:100px;display: inline-block;border-radius: 15px;background-color: #EBEDF0;position:relative;}
.imagefile {display:inline-flex !important;justify-content: center !important;align-items:center !important;}
.large span {display: inline-block;font-size:12px;margin-left:20px;color:#f56c6c;}

.middle {cursor: pointer;width:auto !important;width:70px !important;height:70px;position:relative;}
.middle .el-image {width:70px;height:70px;display: inline-block;border-radius: 15px;background-color: #EBEDF0;position:relative;}
.imagefile {display:inline-flex !important;justify-content: center !important;align-items:center !important;}
.middle span {display: inline-block;font-size:12px;margin-left:20px;color:#f56c6c;}

.small {cursor: pointer;width:auto !important;width:50px !important;height:50px;position:relative;}
.small .el-image {width:50px;height:50px;display: inline-block;border-radius: 15px;background-color: #EBEDF0;position:relative;}
.imagefile {display:inline-flex !important;justify-content: center !important;align-items:center !important;}
.small span {display: inline-block;font-size:12px;margin-left:20px;color:#f56c6c;}

.banner {cursor: pointer;width:auto !important;width:150px !important;height:70px;position:relative;}
.banner .el-image {width:150px;height:70px;display: inline-block;border-radius: 15px;background-color: #EBEDF0;position:relative;}
.imagefile {display:inline-flex !important;justify-content: center !important;align-items:center !important;}
.banner span {display: inline-block;font-size:12px;margin-left:20px;color:#f56c6c;} 

::v-deep(.defaultthumb) {display: inline-flex !important;justify-content: center !important;align-items: center !important;}
::v-deep(.defaultthumb .el-image__inner) {width:70px;height: 70px;}

.TTL-upload-btn {display: inline-block;width:100%;margin-bottom:20px;}
</style>